import SystemInfoMessages from './SystemInfoMessages';
import AddSystemInfoMessageModal from './AddSystemInfoMessageModal';
import EditSystemInfoMessageModal from './EditSystemInfoMessageModal';
import NewAccountRequests from './NewAccountRequests';
import UserAccounts from './UserAccounts';
import ProcessNewAccountRequestModal from './ProcessNewAccountRequestModal';
import ViewUserAccountResut from './ViewUserAccountResult';

const Admin = {};

Admin.SystemInfoMessages = SystemInfoMessages;
Admin.ModalAddSystemInfoMessage = AddSystemInfoMessageModal;
Admin.ModalEditSystemInfoMessage = EditSystemInfoMessageModal;
Admin.NewAccountRequests = NewAccountRequests;
Admin.UserAccounts = UserAccounts;
Admin.ProcessNewAccountRequestModal = ProcessNewAccountRequestModal;
Admin.ModalViewUserAccount = ViewUserAccountResut;

export default Admin;